<template>
  <form class="form-horizontal">
    <div class="page-header">
      <span class="glyphicon glyphicon-paperclip"></span>二级页面顶图
    </div>
    <div class="form-group">
      <div class="col-xs-6">
        <div class="media">
          <div class="media-left l-media-left">
            <d-upload
              :url.sync="route.basic.picture"
              class="btn btn-primary btn-block btn-xs"
            >上传图片 3:2</d-upload>
            <img class="img-responsive" :src="route.basic.picture" alt />
          </div>
          <div class="media-body">
            <textarea id cols="30" rows="5" class="form-control" v-model="route.basic.hoverIntro"></textarea>
            <div
              :class="{'text-danger': route.basic.hoverIntro.length > 70}"
            >字数限制：70，已输入：{{route.basic.hoverIntro.length}}</div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="form-group">
      <label class="col-xs-2">
        分类
        <select class="form-control" v-model="route.basic.catalog">
          <option :value="null">-</option>
          <option v-for="item in categories" track-by="$index" :value="item">{{item}}</option>
        </select>
      </label>
      <label class="col-xs-2">
        路线简称
        <input type="text" v-model="route.basic.abbreviation" class="form-control" />
      </label>
      <label class="col-xs-4">
        主标题
        <input type="text" v-model="route.basic.heading" class="form-control" />
      </label>
      <label class="col-xs-4">
        副标题
        <input type="text" v-model="route.basic.title" class="form-control" />
      </label>
      <label class="col-xs-4">
        标签（用于小程序展示）（老版本弃用数据）
        <input type="text" v-model="route.basic.wetag" class="form-control" />
      </label>
      <label class="col-xs-4">
        是否青春
        <div>
          <label class="radio-inline">
            <input type="radio" v-model="route.basic.isYouth" :value="1" />是
          </label>
          <label class="radio-inline">
            <input type="radio" v-model="route.basic.isYouth" :value="0" />否
          </label>
        </div>
      </label>
    </div>
    <!-- <div class="form-group">
      <label class="col-xs-12">
        亮点推荐
        <textarea name="" id="" v-model="route.basic.sparkles" cols="30" rows="3" class="form-control"></textarea>
      </label>
    </div>-->
    <div class="form-group">
      <label class="col-xs-12">城区</label>
      <div class="col-xs-2">
        <select class="form-control" v-model="route.basic.city" v-on:change="changeCity">
          <option :value="null">-</option>
          <option :value="city.name" v-for="city in areas">{{city.name}}</option>
        </select>
      </div>
      <div class="col-xs-2">
        <select class="form-control" v-model="route.basic.cityBlock">
          <option :value="null">-</option>
          <option :value="item" v-for="item in cityBlockList">{{item}}</option>
        </select>
      </div>
    </div>
    <div class="form-group">
      <label class="col-xs-12">目的地</label>
      <div class="col-xs-12">
        <div v-if="destinationList.length === 0">暂无目的的</div>
        <label class="checkbox-inline" v-for="item in destinationList" track-by="$index">
          <input type="checkbox" v-model="route.destinationIdArray" :value="item.id" />
          <span class="vertical-sub">{{item.name}}</span>
        </label>
      </div>
    </div>

    <div class="form-group">
      <label class="col-xs-12">主题（老版本弃用数据）</label>
      <div class="col-xs-12">
        <label class="checkbox-inline" v-for="item in route.terms.theme" track-by="$index">
          <input type="checkbox" v-model="route.basic.termIds" :value="item.id" />
          <span class="vertical-sub">{{item.title}}</span>
        </label>
      </div>
    </div>
    <div class="form-group">
      <label class="col-xs-12">热门路线 最多显示5条 0为不显示在热门路线中</label>
      <div class="col-xs-2">
        <select class="form-control" v-model="route.basic.hotSort">
          <option :value="item" v-for="item in hotSortOption">{{item}}</option>
        </select>
      </div>
    </div>
    <div class="form-group">
      <label class="col-xs-4">
        文化指数 0~5.0星
        <div>
          <select class="form-control" v-model="route.basic.cultureStar">
            <option :value="item" v-for="item in starOption">{{item}}</option>
          </select>
        </div>
      </label>

      <label class="col-xs-4">
        体力指数 0~5.0星
        <div>
          <select class="form-control" v-model="route.basic.physicalStar">
            <option :value="item" v-for="item in starOption">{{item}}</option>
          </select>
        </div>
      </label>
    </div>
    <div class="form-group">
      <label class="col-xs-5">
        特别推荐
        <button type="button" @click="route.routeLabelRelation.recommendLabelId = null" class="btn btn-info">清除选择</button>
        <div style="width: 100%; margin-top: 4px;">
          <label class="checkbox-inline" v-for="item in labelGroup.RECOMMEND" track-by="$index">
            <input
              type="radio"
              v-model="route.routeLabelRelation.recommendLabelId"
              :value="item.id"
            />
            {{item.cnLabel}} {{item.enLabel}}
          </label>
        </div>
      </label>

      <label class="col-xs-6">
        <div style="width:100%; margin-top: 4px;">
          特别推荐背景颜色（用于小程序展示）
          <input
            type="hidden"
            v-model="route.basic.wetagColor"
            class="form-control"
          />
        </div>
        <div
          :class="{'wetagselect': route.basic.wetagColor === item, 'wetagselectno': route.basic.wetagColor != item}"
          v-for="item in wetagcolorlist"
        >
          <div
            v-bind:style="'height: 30px;width: 30px;cursor: pointer;position: absolute;left: 4px;top: 4px;background:'+item;"
            @click="wetagColorClick(item)"
          ></div>
        </div>
        <!--<div style="width: 50px;height:30px;position: relative;float:left;margin-right: 10px;" v-for="item in wetagcolorlist">-->
        <!--<input type="radio" :value="item"  v-model="route.basic.wetagColor">-->
        <!--<div v-bind:style="'height: 30px;width: 30px;position: absolute;left: 20px;top: 0px;background:'+item;" @click="wetagColorClick(item)">-->
        <!--</div>-->
        <!--</div>-->
      </label>
    </div>
    <div class="form-group">
      <label class="col-xs-12">活动系列</label>
      <div class="col-xs-12">
        <label class="checkbox-inline" v-for="item in labelGroup.TYPE" track-by="$index">
          <input type="radio" v-model="route.routeLabelRelation.typeLabelId" :value="item.id" />
          {{item.cnLabel}} {{item.enLabel}}
        </label>
      </div>
    </div>
    <div class="form-group">
      <label class="col-xs-12">活动方式</label>
      <div class="col-xs-12">
        <label class="checkbox-inline" v-for="item in labelGroup.WAY" track-by="$index">
          <input
            type="checkbox"
            v-model="route.routeLabelRelation.wayLabelIdArray"
            :value="item.id"
          />
          <span class="vertical-sub">{{item.cnLabel}} {{item.enLabel}}</span>
        </label>
      </div>
    </div>
    <div class="form-group">
      <label class="col-xs-12">活动主题</label>
      <div class="col-xs-12">
        <label class="checkbox-inline" v-for="item in labelGroup.THEME" track-by="$index">
          <input
            type="checkbox"
            v-model="route.routeLabelRelation.themeLabelIdArray"
            :value="item.id"
          />
          <span class="vertical-sub">{{item.cnLabel}} {{item.enLabel}}</span>
        </label>
      </div>
    </div>
    <div class="form-group">
      <label class="col-xs-12">福利优惠</label>
      <div class="col-xs-12">
        <label class="checkbox-inline" v-for="item in labelGroup.RULE" track-by="$index">
          <input
            type="checkbox"
            v-model="route.routeLabelRelation.ruleLabelIdArray"
            :value="item.id"
          />
          <span class="vertical-sub">{{item.cnLabel}} {{item.enLabel}}</span>
        </label>
      </div>
    </div>
    <div class="form-group">
      <label class="col-xs-2">
        自定义报名年龄
        <label class="checkbox-inline">
          <input type="radio" v-model="route.basic.isCustomAge" value="0" /> 否
          <input type="radio" v-model="route.basic.isCustomAge" value="1" style="margin-left: 10px;" /> 是
        </label>
      </label>
      <label class="col-xs-2">
        最小年龄
        <input type="text" class="form-control" v-model="route.basic.applyMinAge" />
      </label>
      <label class="col-xs-2">
        最大年龄
        <input type="text" class="form-control" v-model="route.basic.applyMaxAge" />
      </label>
    </div>
    <div class="form-group">
      <label class="col-xs-2">
        平日报名价格
        <input type="text" class="form-control" v-model="route.basic.dailyPrice" />
      </label>
      <label class="col-xs-2">
        当日报名价格
        <input type="text" class="form-control" v-model="route.basic.todayPrice" />
      </label>
      <label class="col-xs-2">
        单位
        <input type="text" class="form-control" v-model="route.basic.unit" placeholder="单位" />
      </label>
      <label class="col-xs-2">
        持续时间(小时)
        <input
          type="number"
          class="form-control"
          v-model="route.basic.duration"
          placeholder="小时"
        />
      </label>
      <label class="col-xs-4">
        结束地点
        <input type="text" class="form-control" v-model="route.basic.endLocation" />
      </label>
      <div class="col-xs-12">
        <label class="checkbox-inline">
          <input
            type="checkbox"
            v-model="route.basic.needInsurance"
            value="true"
            :disabled="route.basic.catalog === 'CW'"
          />
          <span class="vertical-sub">保险</span>
        </label>
        <label class="checkbox-inline">
          <input type="checkbox" v-model="route.basic.needContract" value="true" />
          <span class="vertical-sub">合同</span>
        </label>
        <label class="checkbox-inline">
          <input type="checkbox" v-model="route.basic.needIdCardNo" value="true" />
          <span class="vertical-sub">必填身份证</span>
        </label>
      </div>
    </div>
    <div class="form-group">
      <label class="col-xs-4">
        游览方式
        <input type="text" class="form-control" v-model="route.basic.travelWay" />
      </label>
      <label class="col-xs-4">
        团队规模
        <input type="text" class="form-control" v-model="route.basic.size" />
      </label>
    </div>
    <div class="form-group">
      <div class="col-xs-3">
        停止报名时间类型
        <select name id class="form-control" v-model="route.basic.stopTimeType">
          <option :value="null">-</option>
          <option v-for="(key, val) in stopTimeTypes" :value="key">{{val}}</option>
        </select>
      </div>
    </div>

    <div class="form-group">
      <label class="col-xs-2">
        路线负责人
        <select class="form-control" v-model="route.basic.director">
          <option :value="null">-</option>
          <option v-for="item in managers" track-by="$index" :value="item.id">{{item.name}}</option>
        </select>
      </label>
      <label class="col-xs-2">
        <a v-if="route.basic.leaderGuide" :href="route.basic.leaderGuide" download>带队指南</a>
        <span v-if="!route.basic.leaderGuide">带队指南</span>
        <d-upload :url.sync="route.basic.leaderGuide" class="btn btn-primary btn-block">上传带队指南</d-upload>
      </label>
    </div>
    <div class="form-group">
      <label class="col-xs-3">
        简介标题
        <input type="text" class="form-control" v-model="route.basic.introTitle" />
      </label>
    </div>

    <div style="margin: 1em 0;">
      简介内容
      <button type="button" class="btn btn-warning" @click="addRouteIntro('TEXT', 0)">顶部添加文字模块</button>
      <button type="button" class="btn btn-success" @click="addRouteIntro('PICTURE', 0)">顶部添加图片模块</button>

      <div v-for="item in route.basic.routeIntroList" class="margin-top-20">
        <div v-if="item.type === 'PICTURE'">
          <d-upload :url.sync="item.pic" class="btn btn-primary">上传图片</d-upload>
          <button type="button" class="btn btn-warning " @click="addRouteIntro('TEXT', $index + 1)">本模块下方添加文字模块</button>
          <button type="button" class="btn btn-success" @click="addRouteIntro('PICTURE', $index + 1)">本模块下方添加图片模块</button>
          <button type="button" class="btn btn-info" @click="delRouteIntro($index)">删除</button>

          <img class="margin-top-5 imagesBox" v-show="item.pic" :src="item.pic">
        </div>

        <div v-else>
          <button type="button" class="btn btn-warning" @click="addRouteIntro('TEXT', $index + 1)">本模块下方添加文字模块</button>
          <button type="button" class="btn btn-success" @click="addRouteIntro('PICTURE', $index + 1)">本模块下方添加图片模块</button>
          <button type="button" class="btn btn-info" @click="delRouteIntro($index)">删除</button>

          <d-editor :content.sync="item.intro" class="margin-top-5"></d-editor>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-xs-12">
        <button type="button" @click="cleanOtherAlert" class="btn btn-primary">清空报名弹窗文案</button>
      </label>

      <label class="col-xs-12">
        报名弹窗文案
        <d-editor :content.sync="route.basic.otherAlert"></d-editor>
      </label>
    </div>
    <div class="form-group">
      <div class="col-xs-12 text-center">
        <button type="button" @click="click(submit)($event)" class="btn btn-primary">保存</button>
        <button
          type="button"
          @click="click(submit)($event, '/route/' + this.$route.params.id + '/assembling')"
          class="btn btn-success"
        >保存并下一步</button>
      </div>
    </div>
  </form>
</template>

<script>
import dEditor from '../../components/Editor'
import config from '../../libs/config'
import utils from '../../libs/utils'
import { pick } from 'lodash'
import dUpload from '../../components/Upload'

export default {
  components: {
    dEditor,
    dUpload
  },
  data () {
    return {
      text: '',
      content: '',
      categories: config.categories,
      wetagcolorlist: config.wetagcolorlist,
      areas: config.areas,
      stopTimeTypes: config.stopTimeTypes,
      managers: [],
      labelGroup: {},
      destinationOption: {
        shanghai: [],
        beijing: []
      },
      hotSortOption: [
        0, 1, 2, 3, 4, 5
      ],
      starOption: [
        0, 0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5
      ]
    }
  },
  props: {
    route: {
      coerce (val) {
        val.basic.termIds = val.selectedTerms.map(({ id }) => id)
        if (val.basic.catalog === 'CW') {
          val.basic.needInsurance = true
        }
        return val
      }
    }
  },
  computed: {
    cityBlockList () {
      if (this.route.basic.city) {
        this.route.cityBlock = null
        let selectCity = this.areas.filter(({ name }) => name === this.route.basic.city)[0]
        if (selectCity) {
          return selectCity.sub
        } else {
          return []
        }
      } else {
        return []
      }
    },
    destinationList () {
      if (this.route.basic.city === '上海') {
        return this.destinationOption.shanghai
      } else if (this.route.basic.city === '北京') {
        return this.destinationOption.beijing
      } else {
        return []
      }
    }
  },
  created: function () {
    this.getLabelGroup()
    this.getDestinationList()
  },
  methods: {
    wetagColorClick (item) {
      this.route.basic.wetagColor = item
    },
    // 手动清除报名弹窗文案
    cleanOtherAlert () {
      this.route.basic.otherAlert = ''
    },
    addRouteIntro (type, index) {
      this.route.basic.routeIntroList.splice(index, 0, {
        type: type,
        intro: '',
        pic: ''
      })
      console.log('新增' + index)
      console.log(this.route.basic.routeIntroList)
    },
    delRouteIntro (index) {
      this.route.basic.routeIntroList.splice(index, 1)
      console.log('删除' + index)
      console.log(this.route.basic.routeIntroList)
    },
    submit (next) {
      if (this.route.basic.otherAlert === '<div><br></div>') {
        this.route.basic.otherAlert = ''
      }
      let data = pick(this.route.basic, [
        'picture',
        'wetag',
        'wetagColor',
        'hoverIntro',
        'catalog',
        'abbreviation',
        'title',
        'heading',
        'isYouth',
        'intro',
        'city',
        'cityBlock',
        'dailyPrice',
        'todayPrice',
        'unit',
        'needInsurance',
        'needContract',
        'needIdCardNo',
        'director',
        'introTitle',
        'intro',
        'routeIntroList',
        'termIds',
        'stopTimeType',
        'endLocation',
        'duration',
        'leaderGuide',
        'travelWay',
        'size',
        'hotSort',
        'physicalStar',
        'cultureStar',
        'isCustomAge',
        'applyMinAge',
        'applyMaxAge',
        'needOtherAlert',
        'otherAlert'
      ])
      data.routeLabelRelation = this.route.routeLabelRelation
      data.destinationIdArray = this.route.destinationIdArray

      return this.$http.put(`${config.apiWe}/product/route/${this.$route.params.id}`, data)
        .then(response => {
          if (response.data) {
            window.alert(response.data)
          }
          next && this.$route.router.go(next)
        })
    },
    getManager () {
      return this.$http.get(`${config.apiWe}/adminer/wLeader`)
        .then(({ data }) => {
          this.managers = data
        })
    },
    // 获取标签分组
    getLabelGroup () {
      return this.$http.get(`${config.apiWe}/product/label`)
        .then(({ data }) => {
          this.labelGroup = data
        })
    },
    // 获取目的地list
    getDestinationList () {
      return this.$http.get(`${config.apiWe}/product/destination/list`)
        .then(({ data }) => {
          this.destinationOption = data
        })
    },
    changeCity () {
      this.route.destinationIdArray = []
    },
    click: utils.click
  },
  route: {
    data () {
      return this.getManager()
    }
  }
}
</script>

<style scoped>
.xp-col {
  margin-bottom: 10px;
}
.xp-col .input-group-addon {
  cursor: pointer;
}
.margin-top-5 {
  margin-top: 5px;
}
.margin-top-20 {
  margin-top: 20px;
}
.imagesBox {
  width: 200px;
  display: block;
}
.wetagselect {
  height: 40px;
  width: 40px;
  position: relative;
  margin-right: 5px;
  float: left;
  border: 1px solid #ff0000;
}
.wetagselectno {
  height: 40px;
  width: 40px;
  position: relative;
  margin-right: 5px;
  float: left;
  border: 1px solid #e8e8e8;
}
</style>



/** WEBPACK FOOTER **
 ** Basic.vue?0c6af485
 **/